// extracted by mini-css-extract-plugin
export default {"card":"style_card__N6WQz","cardSection":"style_cardSection__bNus-","circle_count_red":"style_circle_count_red__xK995","circle_parent_element":"style_circle_parent_element__tF0+-"};